<template>
  <div v-if="isdisplay" class="prd-overlay" @click.self="close">
    <div class="prd-dialog">

      <!-- Header -->
      <div class="prd-head">
        <div class="prd-head-left">
          <div class="prd-head-icon"><i class="ri-barcode-line"></i></div>
          <div class="prd-head-txt">
            <span>Recevoir par douchette</span>
            <small>Le panier du téléphone client</small>
          </div>
        </div>
        <button class="prd-close" @click="close" aria-label="Fermer">
          <i class="ri-close-line"></i>
        </button>
      </div>

      <!-- Body -->
      <div class="prd-body">

        <div class="prd-hint">
          <i class="ri-qr-scan-2-line"></i>
          <span>Présentez le QR affiché sur le téléphone du client à la douchette.</span>
        </div>

        <textarea
            ref="zone"
            v-model="txt"
            :class="['prd-zone', { 'prd-zone-err': erreur !== '' }]"
            rows="5"
            spellcheck="false"
            autocomplete="off"
            placeholder="En attente du scan…"
            @keydown.enter.prevent="tenterValidation"
        ></textarea>

        <div class="prd-meta">
          <span :class="['prd-count', { 'prd-count-on': txt.length > 0 }]">
            <i class="ri-text"></i> {{ txt.length }} caractère(s)
          </span>
          <button class="prd-paste" @click="coller" title="Coller depuis le presse-papier">
            <i class="ri-clipboard-line"></i> Coller
          </button>
        </div>

        <div v-if="erreur" class="prd-err">
          <i class="ri-error-warning-line"></i>
          <span>{{ erreur }}</span>
        </div>

      </div>

      <!-- Footer -->
      <div class="prd-foot">
        <button class="prd-btn-sec" @click="close">Annuler</button>
        <button class="prd-btn-pri" @click="tenterValidation" :disabled="txt.length === 0">
          <i class="ri-check-line"></i> Valider
        </button>
      </div>

    </div>
  </div>
</template>

<script>
import { parsePayloadScanGo } from "@/service/scangopanier";

const DELAI_AUTOVALIDATION = 120;

export default {
  /* eslint-disable */
  name: "modalreceptiondouchette",

  data() {
    return {
      isdisplay: false,
      txt: "",
      erreur: "",
      dejaValide: false,
      timerauto: null,
    };
  },

  watch: {
    /* Toutes les douchettes ne terminent pas par un Entrée : certaines envoient
       un Tab, d'autres rien. On valide donc dès que le texte reçu forme un
       panier complet, sans attendre. Le délai laisse la douchette finir sa
       frappe - sinon on parserait un JSON tronqué à chaque caractère. */
    txt() {
      this.erreur = "";
      if (this.timerauto) clearTimeout(this.timerauto);
      if (this.txt.trim() === "") return;
      this.timerauto = setTimeout(() => {
        if (parsePayloadScanGo(this.txt)) this.tenterValidation();
      }, DELAI_AUTOVALIDATION);
    },
  },

  methods: {
    /* Idempotente : l'Entrée de la douchette et le watch peuvent la déclencher
       coup sur coup, or un double emit ouvrirait deux fois la modal de contrôle. */
    tenterValidation() {

      console.log('tenterValidation', this.txt);

      if (this.dejaValide) return;
      const brut = this.txt;
      if (String(brut || "").trim() === "") return;

      console.log('tenterValidation brut', brut);

      if (!parsePayloadScanGo(brut)) {
        this.erreur = "QR non reconnu. Vérifiez que la douchette est bien configurée, ou réessayez.";
        
        console.log('tenterValidation erreur', this.erreur);
        this.txt = "";
        this.focusZone();
        return;
      }

      this.dejaValide = true;
      if (this.timerauto) { clearTimeout(this.timerauto); this.timerauto = null; }
      this.isdisplay = false;
      this.$emit('recu', brut);
    },

    async coller() {
      try {
        const t = await navigator.clipboard.readText();
        if (t) this.txt = t;
      } catch (e) {
        /* Presse-papier refusé (hors HTTPS, ou permission) : la saisie manuelle reste possible. */
        this.erreur = "Presse-papier inaccessible : collez avec Ctrl+V dans la zone.";
        this.focusZone();
      }
    },

    focusZone() {
      this.$nextTick(() => { if (this.$refs.zone) this.$refs.zone.focus(); });
    },

    close() {
      if (this.timerauto) { clearTimeout(this.timerauto); this.timerauto = null; }
      this.isdisplay = false;
    },

    show() {
      /* Réinitialisation complète : sans ça, le panier suivant hériterait de
         l'état du précédent (dejaValide notamment, qui bloquerait tout). */
      this.txt = "";
      this.erreur = "";
      this.dejaValide = false;
      if (this.timerauto) { clearTimeout(this.timerauto); this.timerauto = null; }
      this.isdisplay = true;
      this.focusZone();
    },
  },

  beforeUnmount() {
    if (this.timerauto) clearTimeout(this.timerauto);
  },

  mounted() {},
};
</script>

<style scoped>
/* ── Overlay ── */
.prd-overlay {
  position: fixed; inset: 0; z-index: 10030;
  background: rgba(0, 0, 0, .55);
  display: flex; align-items: center; justify-content: center;
  padding: 16px;
  font-family: 'Segoe UI', system-ui, sans-serif;
}

/* ── Dialog ── */
.prd-dialog {
  background: var(--surface); border: 1px solid var(--border);
  border-radius: 14px; width: min(480px, 100%);
  display: flex; flex-direction: column; overflow: hidden;
  box-shadow: 0 24px 60px rgba(0, 0, 0, .45);
  animation: prd-in .2s cubic-bezier(.4, 0, .2, 1);
}
@keyframes prd-in {
  from { opacity: 0; transform: scale(.93) translateY(10px); }
  to   { opacity: 1; transform: none; }
}

/* ── Header ── */
.prd-head {
  display: flex; align-items: center; justify-content: space-between;
  padding: 14px 18px; border-bottom: 1px solid var(--border); flex-shrink: 0;
}
.prd-head-left { display: flex; align-items: center; gap: 10px; }
.prd-head-icon {
  width: 34px; height: 34px; border-radius: 9px; flex-shrink: 0;
  background: color-mix(in srgb, var(--accent) 15%, transparent);
  color: var(--accent); font-size: 17px;
  display: flex; align-items: center; justify-content: center;
}
.prd-head-txt { display: flex; flex-direction: column; line-height: 1.3; }
.prd-head-txt span { font-size: 14px; font-weight: 800; color: var(--text); }
.prd-head-txt small { font-size: 11px; color: var(--text2); }
.prd-close {
  background: none; border: none; color: var(--text2); font-size: 20px;
  cursor: pointer; line-height: 1; padding: 4px; border-radius: 6px;
  transition: color .12s;
}
.prd-close:hover { color: var(--red); }

/* ── Body ── */
.prd-body {
  padding: 18px; display: flex; flex-direction: column; gap: 10px;
}
.prd-hint {
  display: flex; align-items: center; gap: 9px;
  background: color-mix(in srgb, var(--accent) 10%, transparent);
  border: 1px dashed var(--accent); border-radius: 10px;
  padding: 11px 13px; color: var(--text2); font-size: 12px; line-height: 1.4;
}
.prd-hint i { font-size: 22px; color: var(--accent); flex-shrink: 0; }

.prd-zone {
  width: 100%; padding: 12px; border-radius: 10px;
  background: var(--surface2); border: 2px solid var(--accent);
  color: var(--text); outline: none; resize: vertical;
  font-family: ui-monospace, 'Consolas', monospace;
  font-size: 12px; line-height: 1.5;
  transition: border-color .15s;
  scrollbar-width: thin; scrollbar-color: var(--border) transparent;
}
.prd-zone::placeholder { color: var(--text3); }
.prd-zone-err { border-color: var(--red); }

.prd-meta { display: flex; align-items: center; justify-content: space-between; gap: 8px; }
.prd-count {
  display: inline-flex; align-items: center; gap: 5px;
  font-size: 11px; font-weight: 700; color: var(--text3);
}
.prd-count-on { color: var(--green); }
.prd-paste {
  display: inline-flex; align-items: center; gap: 5px;
  padding: 6px 11px; border-radius: 7px;
  background: var(--surface2); border: 1px solid var(--border);
  color: var(--text2); font-size: 11px; font-weight: 700;
  cursor: pointer; font-family: inherit; transition: all .12s;
}
.prd-paste:hover { border-color: var(--accent); color: var(--text); }

.prd-err {
  display: flex; align-items: flex-start; gap: 7px;
  background: color-mix(in srgb, var(--red) 12%, transparent);
  border: 1px solid var(--red); border-radius: 9px;
  padding: 9px 11px; color: var(--red); font-size: 11.5px; line-height: 1.45;
}
.prd-err i { font-size: 14px; flex-shrink: 0; margin-top: 1px; }

/* ── Footer ── */
.prd-foot {
  display: flex; gap: 8px; justify-content: flex-end;
  padding: 14px 18px; border-top: 1px solid var(--border); flex-shrink: 0;
}
.prd-btn-sec {
  padding: 9px 16px; border-radius: 8px;
  background: var(--surface2); border: 1px solid var(--border);
  color: var(--text2); font-size: 13px; font-weight: 600;
  cursor: pointer; font-family: inherit; transition: all .12s;
}
.prd-btn-sec:hover { border-color: var(--red); color: var(--red); }
.prd-btn-pri {
  display: flex; align-items: center; gap: 6px;
  padding: 9px 20px; border-radius: 8px; border: none;
  background: var(--accent); color: #fff; font-size: 13px; font-weight: 700;
  cursor: pointer; font-family: inherit; transition: opacity .12s;
}
.prd-btn-pri:hover:not(:disabled) { opacity: .88; }
.prd-btn-pri:disabled { opacity: .4; cursor: not-allowed; }

/* ── Mobile bottom-sheet ── */
@media (max-width: 640px) {
  .prd-overlay { align-items: flex-end; padding: 0; }
  .prd-dialog {
    width: 100%; border-radius: 16px 16px 0 0;
    animation: prd-slide-up .25s cubic-bezier(.4, 0, .2, 1);
  }
}
@keyframes prd-slide-up {
  from { transform: translateY(100%); opacity: 0; }
  to   { transform: translateY(0);    opacity: 1; }
}
</style>
